import script from "./Storybook.vue?vue&type=script&lang=ts&setup=true"
export * from "./Storybook.vue?vue&type=script&lang=ts&setup=true"

import "./Storybook.vue?vue&type=style&index=0&id=6edc4dec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6edc4dec"]])

export default __exports__